// extracted by mini-css-extract-plugin
module.exports = {"baseGrid":"Home_baseGrid__5iHw2","main":"Home_main__zgAJj Home_baseGrid__5iHw2","pageHeader":"Home_pageHeader__Y8w6l"};